import React, { useEffect } from 'react';
import styled from 'styled-components';
import { RiKakaoTalkFill } from 'react-icons/ri';
import { isMobile } from '../common/style';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
    Kakao: any;
  }
}

type TextType = {
  text1: string;
  text2: string;
};

const ShareKakao: React.FC<TextType> = ({ text1, text2 }) => {
  const url = 'https://balabalancegame.netlify.app';

  useEffect(() => {
    ShareKakao();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ShareKakao = () => {
    if (window.Kakao) {
      const kakao = window.Kakao;
      if (!kakao.isInitialized()) {
        kakao.init(process.env.REACT_APP_KAKAO_KEY);
      }
      kakao.Share.createDefaultButton({
        container: '#kakao-link-btn',
        objectType: 'feed',
        content: {
          title: '밸러밸런스게임',
          description: text1 + ' vs ' + text2,
          imageUrl: 'https://i.ibb.co/Btz5RVp/Group-23.png',
          link: {
            webUrl: url,
            mobileWebUrl: url,
          },
        },
        buttons: [
          {
            title: '밸런스 게임 하러가기',
            link: {
              webUrl: url,
            },
          },
        ],
      });
    }
  };

  return (
    <ShareBtn id="kakao-link-btn">
      <RiKakaoTalkFill className="icons" color="#566D62" />
    </ShareBtn>
  );
};

export default ShareKakao;

const ShareBtn = styled.button`
  width: 86px;
  height: 86px;
  padding: 16px;
  border-radius: 100px;
  background: #dcf0e9;
  border: 3px solid #3d6c5b;
  box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.25);
  margin: 0 40px;

  &:hover {
    cursor: pointer;
    background: #86baa7;
  }

  ${isMobile} {
    width: 50px;
    height: 50px;
    padding: 8px;
    margin: 0 18px;
    border: 2px solid #3d6c5b;
  }

  .icons {
    font-size: 48px;

    ${isMobile} {
      font-size: 27px;
    }
  }
`;
